// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ol-z","tupacHeader":"Pl-z","tupacHeader2":"Ql-z","tupacMenu":"Rl-z","tupacMenu2":"Sl-z","tupacMain":"Tl-z","tupacMain2":"Ul-z"};